import { WarningIcon } from "@chakra-ui/icons";
import {
  ModalCorrigirUserBanco,
  openModalCorrigirUserBanco
} from "./modal-corrigir-user-banco";
import { openModalCorrigirErroValidacaoCSV } from "./modal-corrigir-erro-validacao";
import { IconButtonWithLoading } from "components/mailing-components/mailing-table/icon-button-with-loading";
import { useRouter } from "router-manager/parts";
import { StatesMachine } from "components/pipeline-components/classes/state-machine/state-machine";
import { ModalOpcoesCorrigirValidacao } from "./modal-opcoes-corrigir-validacao";
import { StateStatsEvent } from "components/pipeline-components/classes/state-machine/state";

export function ActionButtons({
  stats,
  pipelineData
}: {
  stats: StateStatsEvent;
  pipelineData: StatesMachine | undefined;
}) {
  const router = useRouter();
  const mailingId = router.pathVariable.get("id")!;
  const pipelineId = pipelineData?.id!;

  const statusActions = new Map<number, () => Promise<void>>([
    [
      401, // Erro de usuário banco
      async () => {
        openModalCorrigirUserBanco({ username: "", password: "" });
      }
    ],
    [
      403, // Erro de usuário banco
      async () => {
        openModalCorrigirUserBanco({ username: "", password: "" });
      }
    ],
    [
      411, // Erro de validação do CSV Endereço
      async () => {
        await openModalCorrigirErroValidacaoCSV({
          mailingId,
          pipelineId,
          errorType: "ENDERECO"
        });
      }
    ],
    [
      410, // Erro de validação do CSV Dados Bancários
      async () => {
        await openModalCorrigirErroValidacaoCSV({
          mailingId,
          pipelineId,
          errorType: "DADOS_BANCARIOS"
        });
      }
    ]
  ]);

  const action = statusActions.get(stats.code);

  if (!action) return null;

  return (
    <>
      <IconButtonWithLoading
        aria-label="Ações"
        tooltipMessage="Ações"
        size="xs"
        variant="danger"
        icon={<WarningIcon w="3" h="3" />}
        onClick={async () => {
          await action();
        }}
      />

      <ModalCorrigirUserBanco />
      <ModalOpcoesCorrigirValidacao />
    </>
  );
}
